import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const DEPARTMENT_SHOW = "department/show";

export const showDepartment = createAsyncThunk(DEPARTMENT_SHOW, async (thunkAPI) => {
  try {
    const department = new DataSource({
      store: new ODataStore({
        url: `${baseUrl}Department`,
        key: "Oid",
        version: 4,
        beforeSend: (request) => {
          request.headers["token"] = token;
        },
      }),
      // expand: ["Employee($expand=Department,Position)"],
    });
    return department
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

